import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { Button } from '../../../Controls/Button/index.js';
import Icons from '../../../Elements/Icons/index.js';
import { ListItem } from '../styled.js';
export const CreatableListItem = memo(function CreatableListItem({ item, formatOptionLabel, disabled, isEditMode, dataTestId, onRemove, onSelect, }) {
    const handleClick = useCallbackRef((e) => {
        e.preventDefault();
        e.stopPropagation();
        onRemove(item.value);
    });
    const handleSelect = useCallbackRef(() => onSelect?.(item));
    return (_jsxs(ListItem, { "data-testid": dataTestId && `${dataTestId}-item-${encodeURIComponent(item.value)}`, $isClickable: !!onSelect, onClick: onSelect ? handleSelect : undefined, children: [_jsx("span", { children: formatOptionLabel?.(item) ?? item.label }), isEditMode && (_jsx(Button, { ghost: true, disabled: disabled, "data-testid": dataTestId && `${dataTestId}-remove-${encodeURIComponent(item.value)}`, onClick: handleClick, children: _jsx(Icons.Remove, {}) }))] }));
});
